<template>
    <div v-if="onlineBooking" class="dropup onlinebooking-language-select">
        <span id="language-switcher" data-toggle="dropdown" aria-haspopup="true">
            <i class="zmdi zmdi-globe-alt"></i>
            <span class="hidden-xs hidden-sm">{{ currentCountry.name }}</span>
            <span class="hidden-md hidden-lg uppercase">{{ currentCountry.locale }}</span>
        </span>
        <ul class="dropdown-menu" :class="{'dropdown-menu-right': isClientMobile}" aria-labelledby="language-switcher">
            <li v-for="country in countries" @click="changeCountry(country)" :key="country.key"><a href="#">{{ country.name }}</a></li>
        </ul>
    </div>
    <div v-else class="login-language-select" :class="{'login-language-select-practize': practizeShell}">
        <svg v-if="practizeShell" class="login-language-icon" viewBox="0 0 20 20" fill="none" aria-hidden="true">
            <circle cx="10" cy="10" r="8" stroke="currentColor" stroke-width="1.5"/>
            <path d="M2.5 10H17.5M10 2C12 4.2 13 6.8 13 10C13 13.2 12 15.8 10 18M10 2C8 4.2 7 6.8 7 10C7 13.2 8 15.8 10 18" stroke="currentColor" stroke-width="1.5"/>
        </svg>
        <img v-else src="/images/icons/earth.svg" alt="" />
        {{ currentCountry.name }}
        <ul>
            <li v-for="country in countries" @click="changeCountry(country)" :key="country.key">
                {{ country.name }}
            </li>
        </ul>
    </div>
</template>

<script>
import axios from 'axios';
import IsClientMobile from 'App/components/mixins/IsClientMobile';

export default {
    name: 'LocaleSelector',

    mixins: [
        IsClientMobile,
    ],

    data() {
        return {
            currentLocale: Lang.locale(),
            countries: [
                { key: 'en', name: 'English', locale: Config.get('countries.en.locale') },
                { key: 'da', name: 'Dansk', locale: Config.get('countries.da.locale') },
                { key: 'se', name: 'Svenska', locale: Config.get('countries.se.locale') },
                { key: 'no', name: 'Norwegian Bokmål', locale: Config.get('countries.no.locale') },
            ],
        };
    },

    props: {
        onlineBooking: {
            required: false,
            default: false
        },
        practizeShell: {
            required: false,
            type: Boolean,
            default: false,
        },
    },

    mounted() {
        this.$root.$on('countryUpdated', country => {
            this.currentLocale = Lang.locale();
            this.$forceUpdate();
        });
    },

    methods: {
        changeCountry(country) {
            const newLocale = Config.get(`countries.${country.key}.locale`);

            if (this.onlineBooking) {

                axios
                    .post('/set-ob-locale', { country: newLocale })
                    .then(() => {
                        window.location.reload();
                    })
                    .catch(() => {});
                return;
            }

            Lang.setLocale(newLocale);
            this.$root.$emit('countryUpdated', country);

            axios
                .post('/set-country', { country: newLocale })
                .then(() => {})
                .catch(() => {});
        },
    },

    computed: {
        currentCountry() {
            return this.countries.find(country => country.locale === this.currentLocale);
        },
    },
}
</script>

<style lang="scss">

.onlinebooking-language-select{
    cursor: pointer;
    display: inline;

    a{
        color: #58666e !important;
    }
}

.login-language-select {
    position: absolute;
    padding: 10px;
    left: 1.5rem;
    bottom: 1.5rem;
    color: #fff;
    display: flex;
    align-items: center;
    font-size: 13px;
    cursor: pointer;
}

.login-language-select ul {
    padding: 20px;
    position: absolute;
    left: 5px;
    bottom: 14px;
    display: none;
}

.login-language-select:hover ul {
    display: block;
    background: #547164;
    border-radius: 10px;
    box-shadow: 0 0 20px 0 #3c574a;
}

.login-language-select li {
    list-style: none;
    padding: 0;
    margin-bottom: 8px;
    white-space: nowrap;
}

.login-language-select li:last-of-type {
    margin: 0;
}

.login-language-select li:hover {
    color: #dedede;
}

.login-language-select img {
    width: 16px;
    height: 16px;
    margin-right: 10px;
}
</style>
